import {
  Breakpoints,
  BreakpointWrapper,
  Container,
  ContainerPadding,
  ContainerWrap,
  styled,
  Text,
  TextAppearance,
} from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MultipleCTASelection, ImageCarNoColorBG } from 'src/components';
import { CTAsSiNo } from 'src/feature-app/InputsValues/CTAsObjects';
import { OneElementTemplateFullScreen, useFaContent, useGetIdVehicle } from 'src/feature-app';
import { getVilmaData } from 'src/bff';
import { useWindowHeight } from '@react-hook/window-size';
import { OneFormState } from 'src/types';



const LayoutWrapper = styled.div`
  @media all and (min-width: 960px) {
    display: flex;
  }
`;

const InfoWrapper = styled.div`
  width: 100%;
  padding-left: var(--size-grid002);
  padding-right: var(--size-grid002);
  @media all and (min-width: 960px) {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: var(--size-grid012);
    padding-left: var(--size-grid002);
    padding-right: 0;
    padding-top: 0;
  }
  @media all and (min-width: 1280px) {
    padding-left: var(--size-grid003);
  }
  @media all and (min-width: 1600px) {
    padding-left: var(--size-grid002);
  }
`;


export const FirstStepCEM = () => {
  const { formData } = useSelector((state: OneFormState) => state);
  const dispatch = useDispatch();
  const [model, setModel] = useState(null);
  const { concesion } = formData.fields;
  const [imageSrc, setImageSrc] = useState(null);
  const [dataVilma, setDataVilma] = useState(null);
  const idVehicle = useGetIdVehicle();
  const idVehicleModel = idVehicle.DESC_Model__c;
  const frame = idVehicle.Frame__c.trim();
  const urlParams = new URLSearchParams(window.location.search);
  const modelUrl = urlParams.get('model');
  const faContent = useFaContent();
  const isVenta = (faContent.cem === 'VENTA' || faContent.encuesta === 'CEM - VENTA');
  const height = useWindowHeight();

  const dataVilmaRequest = async () => {
    const data = await getVilmaData(frame);
    //Respuesta cuando el bastidor no es correcto {message: 'No image found for VIN [WVWZZZAUZLW025556]', context: 'the requested image is not available'}
    if(data && data.status === 200) {
      setDataVilma(data.data.content);
    } 
  };

  useEffect(() => {
    if (!dataVilma || !dataVilma.assets) {
      setImageSrc(null);
    } else if (dataVilma) {
      const frontRight = dataVilma.assets.find((e: any) => e.view === 'Front_Right'); 
      frontRight === undefined ? setImageSrc(null) : setImageSrc(frontRight.url);
    }
  }, [dataVilma]);

  useEffect(() => {
    if (idVehicleModel !== 'null') {
      setModel(idVehicleModel);
      dataVilmaRequest();
    } else if (modelUrl) {
      setModel(modelUrl);
      dispatch({ type: 'UPDATE_FIELDS', payload: { modelo: modelUrl } });
    } else {
      setModel(null);
    }
  }, []);


  return (
    dataVilma && imageSrc ? (
      <LayoutWrapper className='layout-wrapper'>
        {
          height <= 600 ? null : (
            <BreakpointWrapper max={Breakpoints.b960}>
              <ImageCarNoColorBG noMargins image={imageSrc} modelName={model} />
            </BreakpointWrapper>
          )
        } 
        
        <InfoWrapper className='info-wrapper'>
          <Container padding={{ bottom: ContainerPadding.static350 }} wrap={ContainerWrap.always}>
            <Text appearance={TextAppearance.headline350}>
              {isVenta ?
                (
                  <>
                    Según nuestros datos, compraste un <Text bold>{model}</Text> en <Text bold>{concesion}</Text>
                  </>
                )
                : (
                  <>
                    Según nuestros datos, visitaste el Servicio Oficial{' '}<Text bold>{concesion}</Text>{' '}con tu{' '}<Text bold>{model}</Text>.
                  </>
                )}
            </Text>
            <Text appearance={TextAppearance.copy0250} staticSize>
              {isVenta ?
                (
                  <>
                    ¿Puedes confirmar que estos datos son correctos?
                  </>
                )
                : (
                  <>
                    ¿Puedes confirmar que estos datos son correctos y que eres la persona que mejor nos puede informar sobre la última visita al taller?
                  </>
                )}
            </Text>
            <MultipleCTASelection ctaValues={CTAsSiNo} name='datosCorrectos' ctaWidth='81' nextOnClick />
          </Container>
        </InfoWrapper>
        <BreakpointWrapper min={Breakpoints.b960}>
          <ImageCarNoColorBG noMargins image={imageSrc} modelName={model} />
        </BreakpointWrapper>
      </LayoutWrapper>
      ) : (
        <OneElementTemplateFullScreen
          element={
            <div style={{ paddingTop: '8px' }}>
              <Text appearance={TextAppearance.headline350}>
                Según nuestros datos, visitaste el Servicio Oficial{' '}<Text bold>{concesion}</Text>{' '}con tu{' '}<Text bold>{model}</Text>.
              </Text>
              <Text appearance={TextAppearance.copy0250} staticSize>
                ¿Puedes confirmar que estos datos son correctos y que eres la persona que mejor nos puede informar sobre la última visita al taller?
              </Text>
              <MultipleCTASelection ctaValues={CTAsSiNo} name='datosCorrectos' ctaWidth='81' nextOnClick />
            </div>
          }
        />
      )
  );
};
